<template>
  <div class="special-skills">
    <h3 class="page-title">玩转专项，so easy！技术深度，精益求精</h3>
    <el-card>
      <div class="toolbar">
        <el-input
          v-model="searchQuery"
          placeholder="搜索技能名称或描述"
          clearable
        />
      </div>
      <el-table
        :data="pagedTopics"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="名字"
          min-width="140"
        />
        <el-table-column
          prop="intro"
          label="简要描述"
          min-width="260"
          show-overflow-tooltip
        />
        <el-table-column
          label="操作"
          width="120"
          align="right"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="goPractice(row)"
            >
              去练习
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="filteredTopics.length"
          layout="prev, pager, next"
          background
        />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SpecialSkills",
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      pageSize: 10,
      topics: [
        // 编程与脚本语言
        {
          name: "Bash",
          intro: "运维工程师使用频次最高的脚本语言，适合系统任务和自动化脚本。（必备）",
          route: "/sre-engineering"
        },
        {
          name: "Python3",
          intro: "功能强大的通用编程语言，复杂任务和自动化场景首选。（必备）",
          route: "/sre-engineering"
        },
        {
          name: "awk",
          intro: "强大的文本处理工具，适合日志分析和结构化文本处理。（必备）",
          route: "/sre-engineering"
        },
        {
          name: "sed",
          intro: "流式文本编辑工具，常用于批量替换和配置文件修改。（必备）",
          route: "/sre-engineering"
        },
        {
          name: "JSON / YAML",
          intro: "主流配置文件格式，广泛用于云原生与配置管理工具。（建议掌握）",
          route: "/sre-engineering"
        },
        {
          name: "Golang",
          intro: "云原生与基础设施领域常用语言，生态成熟，部署便捷。（可选）",
          route: "/sre-engineering"
        },
        {
          name: "PowerShell",
          intro: "Windows 环境中的自动化与系统管理脚本语言。（可选）",
          route: "/sre-engineering"
        },
        {
          name: "Data Structures",
          intro: "掌握常用数据结构，提升代码性能与问题抽象能力。（可选）",
          route: "/sre-engineering"
        },
        {
          name: "Algo 常见算法",
          intro: "解决抽象问题和复杂场景的基础，提升思考与优化能力。（可选）",
          route: "/sre-engineering"
        },
        // 核心运维与云原生
        {
          name: "Docker",
          intro: "经典的容器，标准的进程运行环境，快速发放应用",
          route: "/docker",
        },
        {
          name: "Kubernetes",
          intro: "管理容器化应用程序的开源平台",
          route: "/kubernetes",
        },
        {
          name: "Podman",
          intro: "不需要root权限即可运行的容器环境",
          route: "/podman",
        },
        {
          name: "Nginx",
          intro: "高性能的HTTP和反向代理服务器，工程师必会",
          route: "/nginx",
        },
        {
          name: "Redis",
          intro: "流行的高性能内存中键值存储(key-value)系统",
          route: "/redis",
        },
        {
          name: "Zookeeper",
          intro: "a high-performance web server and reverse proxy server",
          route: "/zookeeper",
        },
        {
          name: "Git",
          intro: "广泛使用的分布式版本控制系统，主要指git命令",
          route: "/git",
        },
        {
          name: "Github",
          intro: "互联网软件开发的重要网站之一，版本控制、代码托管和分享平台",
          route: "/github",
        },
        {
          name: "RabbitMQ",
          intro: "高效可靠的消息队列中间件",
          route: "/rabbitmq",
        },
        {
          name: "Minio",
          intro: "提供高性能、与S3兼容的对象存储系统，使用和部署非常简单",
          route: "/minio",
        },
        {
          name: "Markdown",
          intro:
            "十分简单的标记语言，让人们更多地关注写文档的内容本身，最后渲染成HTML",
          route: "/markdown",
        },
        {
          name: "Kafka",
          intro: "流处理平台，提供消息的订阅与发布的消息队列",
          route: "/kafka",
        },
        {
          name: "Zabbix",
          intro: "经典监控工具",
          route: "/zabbix",
        },
        {
          name: "Grafana",
          intro: "监控数据的可视化图形展示平台",
          route: "/grafana",
        },
        {
          name: "Keepalived",
          intro: "虚拟路由冗余协议来实现服务或者网络的高可用",
          route: "/keepalived",
        },
        {
          name: "HAProxy",
          intro: "高性能TCP和HTTP负载均衡",
          route: "/haproxy",
        },
        {
          name: "KVM",
          intro: "基于内核的虚拟机（KVM）",
          route: "/kvm",
        },
        {
          name: "confluence",
          intro:
            "专业的团队知识管理与协同软件，成员之间共享信息、文档协作、集体讨论，信息推送。",
          route: "/confluence",
        },
        {
          name: "prometheus",
          intro: "基于时序数据库的开源监控告警系统，监控后起之秀",
          route: "/prometheus",
        },
        {
          name: "etcd",
          intro: "分布式键值对存储，可靠而快速的保存关键数据并提供访问",
          route: "/etcd",
        },
        // 流行 DevOps / 云技能（无独立练习路由，先占位）
        {
          name: "Linux 基础与 Shell 环境",
          intro: "运维与 SRE 的根基，包括用户管理、权限、服务、网络等核心能力。",
          route: ""
        },
        {
          name: "GitLab CI / Jenkins",
          intro: "持续集成与持续交付平台，自动化构建、测试与发布流水线。",
          route: ""
        },
        {
          name: "Ansible",
          intro: "无代理配置管理与批量自动化运维工具，简单 YAML 即可驱动复杂任务。",
          route: ""
        },
        {
          name: "Terraform",
          intro: "基础设施即代码（IaC）工具，用声明式方式管理云上资源生命周期。",
          route: ""
        },
        {
          name: "ELK / EFK 日志平台",
          intro: "Elasticsearch + Logstash/Fluentd + Kibana/Fluent-bit 组成的日志采集与分析平台。",
          route: ""
        },
        {
          name: "Service Mesh / Istio",
          intro: "微服务流量治理与可观测性方案，实现灰度发布、熔断限流等高级能力。",
          route: ""
        },
        {
          name: "云平台基础（阿里云 / AWS / Azure）",
          intro: "掌握主流云平台的计算、存储、网络与安全基础服务。",
          route: ""
        },
        {
          name: "Observability（Metrics / Tracing / Logging）",
          intro: "通过指标、链路追踪和日志构建系统级可观测性，快速定位问题。",
          route: ""
        },
      ]
    };
  },
  computed: {
    filteredTopics() {
      const q = this.searchQuery.trim().toLowerCase();
      if (!q) {
        return this.topics;
      }
      return this.topics.filter((t) => {
        const name = t.name ? t.name.toLowerCase() : "";
        const intro = t.intro ? t.intro.toLowerCase() : "";
        return name.includes(q) || intro.includes(q);
      });
    },
    pagedTopics() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredTopics.slice(start, end);
    }
  },
  methods: {
    goPractice(row) {
      if (row && row.route) {
        this.$router.push(row.route);
      }
    }
  }
};
</script>

<style scoped>
.special-skills {
  max-width: 1000px;
  margin: 0 auto;
}

.toolbar {
  margin-bottom: 16px;
}

.pagination-wrapper {
  margin-top: 16px;
  text-align: right;
}

.page-title {
  font-size: 21px;
  font-weight: bold;
  color: #2c3e50;
  text-align: right;
  margin: 10px 1rem;
  letter-spacing: 2px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

a {
  text-decoration: none;
  /* 去除下划线 */
}

.router-link-active {
  text-decoration: none;
  /* 确保活动链接也没有下划线 */
}
</style>
